/**
 * @Description
 * @author XuZiYu
 * @date 2022/08/11 14:59:45
*/
import jsBridge from './jsBridge';

let util = {

    /**
     * 大小写转换
     * @param str
     * @return {string}
     */
    toSBC(str) {
        let result = "";
        let len = str.length;
        for (let i = 0; i < len; i++) {
            let cCode = str.charCodeAt(i);
            //全角与半角相差（除空格外）：65248（十进制）
            cCode = (cCode >= 0xFF01 && cCode <= 0xFF5E) ? (cCode - 65248) : cCode;
            //处理空格
            cCode = (cCode === 0x03000) ? 0x0020 : cCode;
            result += String.fromCharCode(cCode);
        }
        return result;
    },
    /**
     * 脱敏
     * @param str
     * @param beginLen
     * @param endLen
     * @return {string}
     */
    desensitization(str,beginLen,endLen){
        let tempStr='';
        let len = str.length;
        let firstStr = str.substring(0,beginLen);
        let lastStr = str.substring(str.length - endLen);
        let middleStr = str.substring(beginLen, len-Math.abs(endLen)).replace(/[\s\S]/ig, '*');
        tempStr = firstStr + middleStr + lastStr;
        return tempStr;
    },
    /**
     * 调用APP方法
     * @param {String} method -方法名
     * @param {Object} data -参数
     */
     callApp(method, data = {}){
      if (jsBridge.hasNativeMethod(method)){
        jsBridge.callBackHandler(method, data);
      }
    }
};
export default{
    install: function (Vue, options) {
        Vue.prototype.$common = util
    }
}
